import { BucketMedia } from '../../../../../graphql/generated'
import MediaDetails from '../../appbar/iconButtons/MediaDetails'
import MediaDownload from '../../appbar/iconButtons/MediaDownload'
import MediaZoom from './MediaZoom'

interface Props {
  media: BucketMedia | null
}

// TODO (NEX-4805): Remove Details button until it can be fixed, as it doesn't
// currently invoke media details properly
// TODO (NEX-4111): Remove Print Shop button until it can be fixed, as it
// redirects to an Access Denied page currently
export default function MediaMenu({ media }: Props) {
  if (!media) {
    return null
  }
  return (
    <>
      <MediaDetails media={media} />
      <MediaDownload media={media} />
      <MediaZoom />
      {/* <MediaPrintShop media={media} /> */}
    </>
  )
}
